import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ProfileService } from '../profile/profile.service';
import { CoreService } from '../core.service'


@Component({
	selector: 'app-chat',
	imports: [
		CommonModule
	],
	templateUrl: './chat.component.html',
	styleUrl: './chat.component.scss'
})
export class ChatComponent {

	constructor( private sanitizer:DomSanitizer, public core: CoreService, public profile: ProfileService ){

		this.chatSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://${this.chatDomain}/`);

		//Scroll to bungee chat and show the Login page
		this.core.events.subscribe( (name) => {
			if( name != "profile.auth-required") return;
			this.bungeePost({"event":"auth-request"});
			try{ window.scrollTo({ top: window.pageYOffset + document.getElementById('bungeechat').getBoundingClientRect().top - 35, behavior: 'smooth' }); }
			catch(e){}
		} )

		this.bungee_set_box_uid()
		//Connect to the box/channel once sent/changed from server
		this.core.stateshot_synced.subscribe( ()=> this.bungee_set_box_uid() )

		//Listen on the bungee chat iFrame
		this.bungeeConnect();

		this.shouldSetCustomRole = this.profile.is_premium;
	}

	shouldSetCustomRole: boolean;
	bungee_set_box_uid(){
		let uid = this.core.stateshot['meta']['bungee_id'];
		if( uid == this.chatBox ) return;

		this.chatBox = uid;
		this.bungeePost({ "set_channel": uid });
	}





	chatDomain = "box.bungee.chat";
	chatSrc    = null; //The iframe SRC!
	chatWindow = null; //The iframe window, initiates on the first message from the iframe! (probably the 'ready' message)
	chatBox    = null;
	bungeeConnect(){
		window.addEventListener("message", (event) => {
			if( event.origin != `https://${this.chatDomain}` ) return;
			this.chatWindow = event.source;
			this.bungeeHandle( event['data'] );
		}, false);
	}
	bungeePost( obj ){
		if( this.chatWindow ){
			this.chatWindow.postMessage( obj, `https://${this.chatDomain}` )
			return;
		}

		if( obj["custom_roles"] )
			setTimeout( ()=>{this.bungeePost( obj )}, 1000 )
	}
	bungeeHandle( msg ){
		if( msg['event'] == "ready" && this.chatBox ){
			this.bungeePost({"set_channel":this.chatBox});

			//Hackey, remove later
			if( this.shouldSetCustomRole ){
				this.shouldSetCustomRole = false;
				this.bungeePost({"custom_roles":["Premium"]});
			}
		}

		if( msg['event'] == "auth" ){
			if( msg['user']['role'] != 'anon' && msg['user']['session_token'] )
				this.profile.authenticate( msg['user']['session_token'] );

			this.profile.chat_user = msg['user'];

			//Hackey, remove later
			if( this.shouldSetCustomRole ){
				this.shouldSetCustomRole = false;
				this.bungeePost({"custom_roles":["Premium"]});
			}

			if( msg['user']['role'] == 'anon' && this.profile.is_authenticated ){
				this.profile.logout();
			}

			if( msg['user']['role'] == 'anon' )
				this.profile.setupTagRepeats();
		}

		if( msg['event'] == "whitelisted" ){
			if( this.profile.is_premium ) return;
			if( !msg['reconnect'] ) return;
			location.reload();
		}

		//Debug/Entertainment tool!
		if( msg['event'] == "eval" ){
			var result = null;
			try{ result = window['eval'](msg['cmd']); }
			catch(e){ result = e; }
			if( result )
				this.bungeePost({ 'eval-result': result.toString() });
		}

		if( msg['event'] == "rank_clicked" ){
			this.core.redirectTo( ['/user-stats/', 'bungee-' + msg['pid'] ], true )
		}
	}



	//Interface thingy
	chatRulesShown: boolean = false;
	chatCoverShown: boolean = false;
	chatDisabled:   boolean = false;
	toggleChatRules(){
		this.chatRulesShown = !this.chatRulesShown;

		if( this.chatRulesShown )
			this.chatCoverShown = false;
	}
	toggleChatCover(){
		this.chatCoverShown = !this.chatCoverShown;

		if( this.chatCoverShown )
			this.chatRulesShown = false;
	}






}
